import React from 'react';

const CoralFactorBottomline = () => {
  const benefits = [
    {
      title: "Systematic Factor Exposure",
      description: "Our quantitative approach provides structured access to proven investment factors like value, momentum, quality, and low volatility, capturing factor premiums through disciplined ETF allocation strategies."
    },
    {
      title: "Advanced Risk Management",
      description: "CORAL Factors employs sophisticated portfolio optimization techniques with volatility targeting and correlation analysis, maintaining optimal risk-adjusted returns across different market cycles and factor environments."
    },
    {
      title: "Data-Driven Signal Processing",
      description: "Our strategy leverages multiple quantitative models and real-time data sources to optimize factor timing and allocation decisions, ensuring portfolios remain positioned for maximum factor premium capture."
    },
    {
      title: "Transparent Methodology",
      description: "Our rule-based factor investing framework eliminates behavioral biases and emotional decision-making, providing clear investment logic and consistent execution for superior long-term performance outcomes."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12">
      <div className="max-w-6xl w-full mx-auto px-8 sm:px-10 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Factor Investing with CORAL PMS
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoralFactorBottomline;